module.exports = __webpack_public_path__ + "static/media/apple-icon.4ac5e7a7.png";